<template>
  <v-card>
    <v-toolbar dark dense color="primary">
      <v-toolbar-title>Карточка пользователя</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="dialogClose">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-container fluid grid-list-lg fill-height class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 sm5 lg4 class="text-xs-center">
            <v-avatar round color="teal" size="250">
              <img v-if="user.image" :src="user.image|avatar" @error="user.image=''" />
              <template v-else>
                <v-icon size="150">person</v-icon>
              </template>
            </v-avatar>
          </v-flex>
          <v-flex xs12 sm7 lg8>
            <p class="display-1">{{ user.last_name+' '+user.first_name+' '+user.mid_name }}</p>
            <v-text-field label="ID" v-model="user.id" disabled></v-text-field>
            <v-text-field hide-details label="Email" v-model="user.email" :disabled="!editMode"></v-text-field>
            <v-checkbox label="Email подтвержден" v-model="user.confirmed_email" :disabled="!editMode"></v-checkbox>
            <v-text-field hide-details label="Телефон" v-model="user.phone" :disabled="!editMode"></v-text-field>
            <v-checkbox label="Телефон подтвержден" v-model="user.confirmed_phone" :disabled="!editMode"></v-checkbox>
            <v-divider></v-divider>
            <v-checkbox hide-details label="Премиум пользователь" v-model="user.premium" disabled></v-checkbox>
            <v-checkbox hide-details label="Бесплатный доступ" v-model="user.is_free" :disabled="!editMode"></v-checkbox>
            <v-checkbox label="Является администратором" v-model="user.is_admin" :disabled="!editMode"></v-checkbox>
            <v-divider></v-divider>
            <v-textarea auto-grow rows="3" label="Комментарий" v-model="user.description" :disabled="!editMode"></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn small color="amber" @click="resetPassword">сбросить пароль</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-if="!editMode" small class="success" @click="editMode=!editMode">
        <v-icon left>edit</v-icon>Редактировать
      </v-btn>
      <v-btn v-else small class="info" @click="submit">
        <v-icon left>save</v-icon>Сохранить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { cloneDeep, keys as objectKeys, isEqual } from 'lodash'
import dialogMixin from '@/mixins/dialog'
import { update, resetPassword } from '@/apps/accounts/api'
export default {
  name: 'UserForm',
  mixins: [dialogMixin],
  props: {
    formData: {
      type: Object,
      required: false,
      default: () => ({
        id: '',
        email: '',
        phone: '',
        last_name: '',
        first_name: '',
        middle_name: ''
      })
    }
  },

  data() {
    return {
      editMode: false,
      user: {}
    }
  },

  watch: {
    formData: {
      handler() {
        this.user = cloneDeep(this.formData)
      },
      deep: true,
      immediate: true
    }
  },

  filters: {
    avatar(token) {
      // @todo  Вынести и сделать параметрическим
      return `https://dantser.com/disk/d/${token}`
    }
  },

  methods: {
    resetPassword() {
      this.$dmsAgree('Точно нужно сбросить пароль?').then(_ => {
        const id = this.user.id
        return resetPassword(id).then(
          _ => {
            this.$dmsInfoNoty('Пароль обновлен')
          },
          error => {
            this.$dmsErrorNoty('Не удалось обновить пароль')
          }
        )
      })
    },

    submit() {
      const id = this.user.id
      const formData = this.getFormData()
      update(id, formData).then(_ => {
        this.$emit('save', id, formData)
        this.dialogClose()
      })
    },

    getFormData() {
      let data = {}
      const userData = this.user
      const originData = this.formData
      objectKeys(userData).forEach(prop => {
        if (!isEqual(userData[prop], originData[prop])) {
          data[prop] = userData[prop]
        }
      })
      return data
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/apps/accounts/components/Forms/UserForm.vue